module.exports = __webpack_public_path__ + "static/media/story-21.b7ad664d.jpg";